module.exports = __webpack_public_path__ + "img/report1.20156bb3.png";